import * as XLSX from "xlsx";

/**
 * 광고 관리 전용 엑셀 다운로드 Exporter
 * 광고주별로 다른 형식의 시트를 생성
 */

// ==================== 광고주별 그룹 정의 ====================
const ADVERTISER_GROUPS = {
  "호올스 저장": { advertiser: "호올스", productTypes: ["저장", "저장+유입"] },
  "호올스 유입": { advertiser: "호올스", productTypes: ["유입"] },
  토스저장: { advertiser: "토스", productTypes: ["저장", "저장+유입"] },
  토스유입: { advertiser: "토스", productTypes: ["유입"] },
  "버즈빌 저장": { advertiser: "버즈빌", productTypes: ["저장", "저장+유입"] },
  "버즈빌 유입": { advertiser: "버즈빌", productTypes: ["유입"] },
  "기프트 저장": { advertiser: "기프트", productTypes: ["저장", "저장+유입"] },
  "기프트 유입": { advertiser: "기프트", productTypes: ["유입"] },
  베이직: { advertiser: "베이직", productTypes: null },
  "멘토스 저장": { advertiser: "멘토스", productTypes: ["저장", "저장+유입"] },
  "멘토스 유입": { advertiser: "멘토스", productTypes: ["유입"] },
  브라보: { advertiser: "브라보", productTypes: null },
  찰리: { advertiser: "찰리", productTypes: null },
  길찾기저장: { advertiser: "길찾기", productTypes: ["저장", "저장+유입"] },
  길찾기유입: { advertiser: "길찾기", productTypes: ["유입"] },
  당근저장: { advertiser: "당근", productTypes: ["저장", "저장+유입"] },
  당근유입: { advertiser: "당근", productTypes: ["유입"] },
  제주: { advertiser: "제주", productTypes: null },
  투플저장: { advertiser: "투플", productTypes: ["저장", "저장+유입"] },
  투플유입: { advertiser: "투플", productTypes: ["유입"] },
  맛집최적화: {
    advertiser: "최적화",
    productTypes: ["유입"],
    adNameFilter: "맛집 최적화",
  },
  일키전용: {
    advertiser: "최적화",
    productTypes: ["유입"],
    adNameFilter: "일키 전용",
  },
  핫팩: { advertiser: "핫팩", productTypes: null },
  카카오: { advertiser: "카카오", productTypes: null },
  강남: { advertiser: "강남", productTypes: null },
  "일키트래픽 (유입)": {
    advertiser: "일키 트래픽",
    productTypes: ["유입"],
  },
  "일키트래픽 (저장)": {
    advertiser: "일키 트래픽",
    productTypes: ["저장"],
  },
  "일키트래픽 (유입+저장)": {
    advertiser: "일키 트래픽",
    productTypes: ["저장+유입", "유입+저장"],
  },
  썬데이저장: { advertiser: "썬데이", productTypes: ["저장", "저장+유입"] },
  썬데이유입: { advertiser: "썬데이", productTypes: ["유입"] },
  백링크저장: { advertiser: "백링크", productTypes: ["저장", "저장+유입"] },
  백링크유입: { advertiser: "백링크", productTypes: ["유입"] },
  N4저장: { advertiser: "N4", productTypes: ["저장", "저장+유입"] },
  N4유입: { advertiser: "N4", productTypes: ["유입"] },
  화이트저장: { advertiser: "화이트", productTypes: ["저장", "저장+유입"] },
  화이트유입: { advertiser: "화이트", productTypes: ["유입"] },
};

// ==================== 변환 함수들 ====================

/**
 * 호올스 형식 변환
 */
const transformHoolse = ({ meta, campaign }) => {
  const start = new Date(meta.startDate);
  const end = new Date(meta.endDate);
  const deadline = new Date(end);
  deadline.setDate(deadline.getDate() + 1);
  const workingDays = Math.ceil((deadline - start) / (1000 * 60 * 60 * 24));

  return {
    신청자: meta.userName,
    상품: meta.productType,
    접수일: meta.submitDate,
    MID: meta.placeId,
    "플레이스명 (업체명)": meta.placeName,
    "작업키워드 (검색시 키워드 5위 이내)":
      campaign.keywords?.[0]?.adKeyword || "",
    "일 요청량": campaign.dailyInflow,
    시작일: meta.startDate,
    마감일: meta.endDate,
    작업일: workingDays,
    총수량: campaign.totalInflow,
    특이사항: "",
    "정산액(포함)": campaign.totalCost,
    정산: "완료",
    세팅: true,
    검수자: "",
  };
};

/**
 * 토스 형식 변환
 */
const transformToss = ({ meta, campaign }) => {
  const baseData = {
    신청자: meta.userName,
    "플레이스명(업체명)": meta.placeName,
    "플레이스 URL": `https://m.place.naver.com/place/${meta.placeId}`,
    공백1: "",
    공백2: "",
    "요청 트래픽": campaign.dailyInflow,
    공백3: "",
    "검색어(단일 플레이스 키워드 구지도/신지도)":
      campaign.keywords?.[0]?.adKeyword || "",
  };

  if (campaign.productType === "유입") {
    return { ...baseData, 구분: "명소", 시작일자: meta.startDate };
  } else {
    return { ...baseData, 시작일자: meta.startDate };
  }
};

/**
 * 버즈빌 형식 변환
 */
const transformBuzzvil = ({ meta, campaign }) => {
  return {
    신청자: meta.userName,
    시작일: meta.startDate,
    마감일: meta.endDate,
    유입: campaign.dailyInflow,
    키워드: campaign.keywords?.[0]?.adKeyword || "",
    플레이스ID: meta.placeId,
    메모: "",
  };
};

/**
 * 홈런볼 형식 변환
 */
const transformHomeRunBall = ({ meta, campaign }) => {
  return {
    신청자: meta.userName,
    시작일: meta.startDate,
    마감일: meta.endDate,
    유입: campaign.dailyInflow,
    키워드: campaign.keywords?.[0]?.adKeyword || "",
    플레이스ID: meta.placeId,
    메모: "",
  };
};

/**
 * 베이직(구지도) 형식 변환
 */
const transformBasic = ({ meta, campaign }) => {
  const start = new Date(meta.startDate);
  const end = new Date(meta.endDate);
  const workingDays = Math.ceil((end - start) / (1000 * 60 * 60 * 24)) + 1;

  return {
    신청자: meta.userName,
    요청일: meta.submitDate,
    시작일: meta.startDate,
    종료일: meta.endDate,
    작업일: workingDays,
    검색어: campaign.keywords?.[0]?.adKeyword || "",
    플레이스ID: meta.placeId,
    일유입량: campaign.dailyInflow,
    플레이스링크: `https://m.place.naver.com/place/${meta.placeId}`,
    상호명: meta.placeName,
    총유입량: campaign.totalInflow,
    세팅유무: "세팅완료",
    정산: "체크",
    입금액: Math.round(campaign.totalCost / 1.1),
    "입금액(VAT포함)": campaign.totalCost,
  };
};

/**
 * 멘토스 형식 변환
 */
const transformMentos = ({ meta, campaign }) => {
  return {
    신청자: meta.userName,
    시작일: meta.startDate,
    마감일: meta.endDate,
    유입: campaign.dailyInflow,
    키워드: campaign.keywords?.[0]?.adKeyword || "",
    플레이스ID: meta.placeId,
    메모: "",
  };
};

/**
 * 브라보/찰리 형식 변환
 */
const transformBravoOrCharlie = ({ meta, campaign }) => {
  const keywords = campaign.keywords?.map((k) => k.adKeyword) || [];

  return {
    신청자: meta.userName,
    "(필수)업체명": meta.placeName,
    "(필수)업체URL": `https://m.place.naver.com/place/${meta.placeId}`,
    "(필수)업체PID번호": meta.placeId,
    "(필수)순위키워드": keywords[0] || "",
    "(필수)일목표\n10 이상": campaign.dailyInflow || 10,
    "(필수)일수\n1 이상": Math.max(1, parseInt(campaign.executionDays) || 1),
    "(필수)검색키워드1\n(5위 이내)": keywords[0] || "",
    "(선택)검색키워드2\n(5위 이내)": keywords[1] || "",
    "(선택)검색키워드3\n(5위 이내)": keywords[2] || "",
    "(선택)검색키워드4\n(5위 이내)": keywords[3] || "",
    "(선택)블로그 URL": "",
  };
};

/**
 * 길찾기 형식 변환
 */
const transformJamonglab = ({ meta, campaign }) => {
  const keywords = campaign.keywords?.map((k) => k.adKeyword) || [];
  const start = new Date(meta.startDate);
  const end = new Date(meta.endDate);
  const deadline = new Date(end);
  deadline.setDate(deadline.getDate() + 1);
  const workingDays = Math.ceil((deadline - start) / (1000 * 60 * 60 * 24));

  return {
    신청자: meta.userName,
    접수일: meta.submitDate,
    시작일: meta.startDate,
    종료일: meta.endDate,
    작업일: workingDays,
    최대참여: campaign.totalInflow,
    하루참여: campaign.dailyInflow,
    공백: "",
    키워드: keywords.join(", "),
    "플레이스 URL": `https://m.place.naver.com/place/${meta.placeId}`,
  };
};

/**
 * 투플/최적화/핫팩 형식 변환
 */
const transformTople = ({ meta, campaign }) => {
  const keywords = campaign.keywords?.map((k) => k.adKeyword) || [];
  const start = new Date(meta.startDate);
  const end = new Date(meta.endDate);
  const deadline = new Date(end);
  deadline.setDate(deadline.getDate() + 1);
  const workingDays = Math.ceil((deadline - start) / (1000 * 60 * 60 * 24));

  return {
    신청자: meta.userName,
    접수일: meta.submitDate,
    시작일: meta.startDate,
    종료일: meta.endDate,
    하루참여: campaign.dailyInflow,
    작업일: workingDays,
    최대참여: campaign.totalInflow,
    플레이스명: meta.placeName,
    키워드: keywords.join(", "),
    "플레이스 URL": `https://m.place.naver.com/place/${meta.placeId}`,
  };
};

/**
 * 호올스/멘토스 신규 양식 변환
 * 컬럼: 시작일, 마감일, 일수량, 키워드, MID값, (공백×2), url, 업체명
 */
const transformHoolseMentos = ({ meta, campaign }) => {
  const keywords = campaign.keywords?.map((k) => k.adKeyword) || [];

  return {
    URL: `https://m.place.naver.com/place/${meta.placeId}`,
    업체명: meta.placeName,
    키워드: keywords.join(", "),
    일수량: campaign.dailyInflow,
    시작일: meta.startDate,
    마감일: meta.endDate,
  };
};

/**
 * 제주 형식 변환
 */
const transformJeju = ({ meta, campaign }) => {
  const start = new Date(meta.startDate);
  const end = new Date(meta.endDate);
  const deadline = new Date(end);
  deadline.setDate(deadline.getDate() + 1);
  const workingDays = Math.ceil((deadline - start) / (1000 * 60 * 60 * 24));

  return {
    신청자: meta.userName,
    "플레이스 URL": `https://m.place.naver.com/place/${meta.placeId}`,
    "순위 조회 키워드": campaign.keywords?.[0]?.adKeyword || "",
    "작업 키워드": campaign.keywords?.[0]?.adKeyword || "",
    작업일수: workingDays,
    "일작업량 (최소50)": campaign.dailyInflow,
    "작업 시작일": meta.startDate,
    메모: "",
  };
};

/**
 * 카카오 형식 변환
 */
const transformKakao = ({ meta, campaign }) => {
  const keywords = campaign.keywords?.map((k) => k.adKeyword) || [];
  const start = new Date(meta.startDate);
  const end = new Date(meta.endDate);
  const deadline = new Date(end);
  deadline.setDate(deadline.getDate() + 1);
  const workingDays = Math.ceil((deadline - start) / (1000 * 60 * 60 * 24));

  return {
    접수일: meta.submitDate,
    시작일: meta.startDate,
    종료일: meta.endDate,
    작업일: workingDays,
    최대참여: campaign.totalInflow,
    하루참여: campaign.dailyInflow,
    " ": "",
    키워드: keywords.join(", "),
    "플레이스 URL": campaign.url || "",
    "  ": "",
    업체명: meta.placeName || "",
  };
};

/**
 * 화이트 형식 변환
 * 컬럼: 시작일 (7일 고정), 슬롯 수량(dailyInflow ÷ 100), 공백, 플레이스 URL, 업체명
 */
const transformWhite = ({ meta, campaign }) => {
  const url = campaign.url || `https://m.place.naver.com/place/${meta.placeId}`;
  const slotQty = Math.round((campaign.dailyInflow ?? 0) / 100);

  return {
    "시작일 (7일 고정)": meta.startDate,
    슬롯수량: slotQty,
    " ": "",
    "플레이스 URL": url,
    업체명: meta.placeName,
  };
};

/**
 * N4 형식 변환
 * 컬럼: 신청자, 접수일, 시작일, 종료일, 작업일, 최대참여, 하루참여, 키워드(공란), 공백, 순위측정키워드(공란), 플레이스 URL, 업체명
 */
const transformN4 = ({ meta, campaign }) => {
  const start = new Date(meta.startDate);
  const end = new Date(meta.endDate);
  const deadline = new Date(end);
  deadline.setDate(deadline.getDate() + 1);
  const workingDays = Math.ceil((deadline - start) / (1000 * 60 * 60 * 24));

  return {
    신청자: meta.userName,
    접수일: meta.submitDate,
    시작일: meta.startDate,
    종료일: meta.endDate,
    작업일: workingDays,
    최대참여: campaign.totalInflow,
    하루참여: campaign.dailyInflow,
    키워드: "",
    " ": "",
    순위측정키워드: "",
    "플레이스 URL": `https://m.place.naver.com/place/${meta.placeId}`,
    업체명: meta.placeName,
  };
};

/**
 * 그룹1 공통 양식 변환
 * 일키트래픽, 맛집최적화, 강남, 당근, 기프트, 버즈빌, 길찾기
 * 컬럼: 접수일, 시작일, 종료일, 작업일, 최대참여, 하루참여, 키워드, (공백×2), 플레이스 URL, 업체명
 */
const transformGroup1 = ({ meta, campaign }) => {
  const keywords = campaign.keywords?.map((k) => k.adKeyword) || [];
  const start = new Date(meta.startDate);
  const end = new Date(meta.endDate);
  const deadline = new Date(end);
  deadline.setDate(deadline.getDate() + 1);
  const workingDays = Math.ceil((deadline - start) / (1000 * 60 * 60 * 24));

  return {
    접수일: meta.submitDate,
    시작일: meta.startDate,
    종료일: meta.endDate,
    작업일: workingDays,
    최대참여: campaign.totalInflow,
    하루참여: campaign.dailyInflow,
    키워드: keywords.join(", "),
    " ": "",
    "  ": "",
    "플레이스 URL": `https://m.place.naver.com/place/${meta.placeId}`,
    업체명: meta.placeName,
  };
};

// ==================== 시트별 변환 함수 매핑 ====================
const SHEET_TRANSFORMERS = {
  "호올스 저장": transformHoolseMentos,
  "호올스 유입": transformHoolseMentos,
  토스저장: transformToss,
  토스유입: transformToss,
  "버즈빌 저장": transformGroup1,
  "버즈빌 유입": transformGroup1,
  "기프트 저장": transformGroup1,
  "기프트 유입": transformGroup1,
  베이직: transformBasic,
  "멘토스 저장": transformHoolseMentos,
  "멘토스 유입": transformHoolseMentos,
  브라보: transformBravoOrCharlie,
  찰리: transformBravoOrCharlie,
  길찾기저장: transformGroup1,
  길찾기유입: transformGroup1,
  당근저장: transformGroup1,
  당근유입: transformGroup1,
  제주: transformJeju,
  투플저장: transformGroup1,
  투플유입: transformGroup1,
  맛집최적화: transformGroup1,
  일키전용: transformTople,
  핫팩: transformTople,
  카카오: transformKakao,
  강남: transformGroup1,
  "일키트래픽 (유입)": transformGroup1,
  "일키트래픽 (저장)": transformGroup1,
  "일키트래픽 (유입+저장)": transformGroup1,
  썬데이저장: transformGroup1,
  썬데이유입: transformGroup1,
  백링크저장: transformGroup1,
  백링크유입: transformGroup1,
  N4저장: transformGroup1,
  N4유입: transformGroup1,
  화이트저장: transformWhite,
  화이트유입: transformWhite,
};

// ==================== 데이터 그룹화 ====================

/**
 * 광고주별/상품타입별로 데이터 그룹화
 * @param {Array} dataToExport - 내보낼 데이터 배열
 * @returns {Object} 그룹화된 데이터
 */
function groupByAdvertiser(dataToExport) {
  // 빈 그룹 초기화
  const groupedData = {};
  Object.keys(ADVERTISER_GROUPS).forEach((key) => {
    groupedData[key] = [];
  });

  dataToExport.forEach((meta) => {
    meta.campaigns?.forEach((campaign) => {
      // 각 그룹 조건에 맞는지 확인
      for (const [groupName, groupConfig] of Object.entries(
        ADVERTISER_GROUPS,
      )) {
        const { advertiser, productTypes, adNameFilter } = groupConfig;

        // 광고주 확인
        if (meta.advertiserName !== advertiser) continue;

        // 상품 타입 확인 (null이면 모든 타입 허용)
        if (productTypes !== null && !productTypes.includes(meta.productType))
          continue;

        // adName 필터 확인 (있는 경우)
        if (adNameFilter && !meta.adName?.includes(adNameFilter)) continue;

        // 조건을 모두 만족하면 해당 그룹에 추가
        groupedData[groupName].push({ meta, campaign });
        break; // 한 그룹에만 추가
      }
    });
  });

  return groupedData;
}

// ==================== 엑셀 파일 생성 ====================

/**
 * 광고 관리용 다중 시트 엑셀 파일 생성 및 다운로드
 * @param {Array} dataToExport - 내보낼 데이터 배열
 * @param {string} fileName - 파일명 (기본값: exported_campaigns.xlsx)
 */
export async function exportAdManagementXlsx(
  dataToExport,
  fileName = "exported_campaigns.xlsx",
) {
  if (!dataToExport || dataToExport.length === 0) {
    throw new Error("다운로드할 데이터가 없습니다.");
  }

  try {
    // 광고주별로 데이터 그룹화
    const groupedData = groupByAdvertiser(dataToExport);

    // 워크북 생성
    const wb = XLSX.utils.book_new();

    // 시트 생성 순서 정의
    const sheetOrder = [
      "호올스 저장",
      "호올스 유입",
      "토스유입",
      "토스저장",
      "버즈빌 유입",
      "버즈빌 저장",
      "기프트 유입",
      "기프트 저장",
      "베이직",
      "멘토스 저장",
      "멘토스 유입",
      "브라보",
      "찰리",
      "길찾기저장",
      "길찾기유입",
      "당근저장",
      "당근유입",
      "제주",
      "투플저장",
      "투플유입",
      "맛집최적화",
      "일키전용",
      "핫팩",
      "카카오",
      "강남",
      "일키트래픽 (유입)",
      "일키트래픽 (저장)",
      "일키트래픽 (유입+저장)",
      "썬데이저장",
      "썬데이유입",
      "백링크저장",
      "백링크유입",
      "N4저장",
      "N4유입",
      "화이트저장",
      "화이트유입",
    ];

    // 각 시트 추가
    sheetOrder.forEach((sheetName) => {
      const data = groupedData[sheetName];
      const transformer = SHEET_TRANSFORMERS[sheetName];

      if (data?.length > 0 && transformer) {
        const transformedData = data.map((row) => transformer(row));
        const ws = XLSX.utils.json_to_sheet(transformedData);
        XLSX.utils.book_append_sheet(wb, ws, sheetName);
      }
    });

    // 엑셀 파일 다운로드
    XLSX.writeFile(wb, fileName);
  } catch (error) {
    console.error("광고 관리 엑셀 내보내기 오류:", error);
    throw new Error(`엑셀 파일 생성 중 오류가 발생했습니다: ${error.message}`);
  }
}

// 그룹 정의 외부 사용 가능하도록 export
export { ADVERTISER_GROUPS, SHEET_TRANSFORMERS };
